// @flow
import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import LinearProgress from '@material-ui/core/LinearProgress';
import { CircularProgress } from '@material-ui/core';

const wrapperStyles = {
  padding: '150px 0 0',
  textAlign: 'center',
};

const useStyles = makeStyles({
  root: {
    flexGrow: 1,
  },
});

const WithLoading = (props: any) => {
  const classes = useStyles();

  return (
    <React.Fragment>
      {props.isLoading ? (
        <div className={classes.root}>
          <LinearProgress
            color="primary"
            variant="determinate"
            value={props.completed}
          />
          <div style={wrapperStyles}>
            <CircularProgress color="primary" size={60} thickness={2} />
          </div>
        </div>
      ) : (
        <React.Fragment>{props.children}</React.Fragment>
      )}
    </React.Fragment>
  );
};

export default WithLoading;
